// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Currency from "../../../../../library/data-source/country-currency/Currency.bs.js";
import * as WalletApiModel from "../api-model/WalletApiModel.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function decodeApiModel(json) {
  return {
          is_updated: json.is_updated,
          wallet_balance: Currency.toCurrency(json.wallet_balance)
        };
}

function execute(json) {
  return decodeApiModel(DeccoUtils$Catalyst.resolveResult(WalletApiModel.t_decode(json), "WalletBalanceEntityMapper.res"));
}

export {
  decodeApiModel ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
